import React from 'react';

import Dividends from '../../../components/drprofile/Dividends';
import { getDividensFull } from '../../utils/apiCalls';

const FullHistoryTable = props => <Dividends endpoint={getDividensFull} {...props} />

export default FullHistoryTable;
